export default {

    LOGIN : "LOGIN", 
    LOGOUT: "LOGOUT",
    RENEW_TOKEN: "RENEWTOKEN",
    SET_USAGE_TIMESTAMP: "TSTMP"
}